const BorrowBaseCalcView = () => {
  return (
    <div className="borrow-base-calc-view">
      <h1>Placeholder for Borrowing Base Calculation View</h1>
    </div>
  );
};

export default BorrowBaseCalcView;
